import { ApiError } from '../shared.api';

/** The server's own explanation of a refusal (e.g. "Wait 20 seconds before asking for another code"), never the raw JSON body. */
export function apiErrorMessage(err: unknown): string | undefined {
  if (!(err instanceof ApiError) || typeof err.body !== 'object' || err.body === null) return undefined;
  const { message } = err.body as { message?: unknown };
  return typeof message === 'string' ? message : undefined;
}
